import tokenHttpClient from "./httpClient";
import { cleanInitialState } from "../reducer/action";
import { encrypt } from "./test";
const AxiosInterceptorsSetup = (dispatch) => {
  tokenHttpClient.interceptors.request.use(
    async (config) => {
      const SPMS_INTERNAL_STATE = JSON.parse(
        localStorage.getItem("SPMS_INTERNAL_STATE")
      );
      var theValueYouWant = config.url.match("/uaa");
      const token = SPMS_INTERNAL_STATE?.auth?.token;
      var UserId = SPMS_INTERNAL_STATE?.auth?.ldapParam?.userId;

      if (token && !theValueYouWant) {
        var UserIdIntoString = UserId.toString();
        var ciphertext = encrypt(JSON.stringify(UserId), UserIdIntoString);
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["If-Match"] = ciphertext;
      }
      else if(config.url.match("/uaa/api/v1/forgetPassword")){
        var UserIdIntoString = localStorage.getItem("email");
        var ciphertext = encrypt(localStorage.getItem("email"), UserIdIntoString);
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["If-Match"] = localStorage.getItem("email");

      }
       else {
        config.headers["If-Match"] = localStorage.getItem("email");
        dispatch(cleanInitialState());
      }
      return config;
    },
    (error) => {
      console.log(error);
    }
  );

  tokenHttpClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 403 || error.response.status === 401) {
        dispatch(cleanInitialState());
      }
    }
  );
};
export default AxiosInterceptorsSetup;
